import { ActionPermission } from '../../types'

export function computeBreadcrumbsPermission(devicesCount: number): ActionPermission {
  if (devicesCount !== 1) return 'disabled'

  return 'enabled'
}
